import Scope from '@core/managers/Scope';
import { getValueByPath } from '@core/utils/value';

const template = {
  BEGIN: '${',
  END: '}',
  DEFAULT_SPLITTER: '||',
};

const getScopedField = <T>(scope: T, childrenScope?: string[]): T => {
  if (!childrenScope) return scope;
  return Object.keys(scope).reduce((acc, key) => {
    if (!childrenScope.includes(key)) return acc;
    return {
      ...acc,
      [key]: scope[key],
    };
  }, {} as T) as T;
};

const extractTargetString = <T>(
  target: string,
  formScope: Scope,
  scope?: Scope,
): T => {
  target = target.toString();
  const lastIndex = target.lastIndexOf(template.BEGIN);
  if (lastIndex === -1) return target as T;

  const substringTemplate = target.substring(
    lastIndex + template.BEGIN.length,
    target.length,
  );

  let match = substringTemplate.substring(
    0,
    substringTemplate.indexOf(template.END),
  );
  const originalMatchLength = match.length;

  let defaultValue: string | number | boolean | Record<string, unknown> = '';
  const parts = match.split(template.DEFAULT_SPLITTER);
  if (parts.length > 1) {
    match = parts[0];
    for (const part of parts) {
      if (
        part.includes('api') ||
        part.includes('global') ||
        part.includes('fields') ||
        part.includes('hooks') ||
        part.includes('configs')
      ) {
        const parse = getValueByPath(scope.getGlobalScope(), part);
        if (parse) {
          defaultValue = parse;
        }

        continue;
      }

      defaultValue = part;
    }
  }

  const scopedTemplateValue = getValueByPath(formScope.getGlobalScope(), match);

  let value =
    typeof scopedTemplateValue === 'undefined'
      ? defaultValue
      : scopedTemplateValue;

  if (typeof value !== 'string' && lastIndex === 0) {
    return value as T;
  }

  try {
    value = JSON.stringify(value).replace(/^"(.*)"$/, '$1');
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return (target.substring(0, lastIndex) +
    value +
    target.substring(
      lastIndex +
        originalMatchLength +
        template.BEGIN.length +
        template.END.length,
      target.length,
    )) as T;
};

export { getScopedField, extractTargetString, template };
